import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client'
import { API_ENDPOINT } from 'config/vars'
import { typePolicies } from './typePolicies'
import { dataIdFromObject } from './dataIdFromObject'
import { createLink } from 'apollo-absinthe-upload-link'
import { errorLink } from './errorLink'
import { authLink } from './authLink'
import { cookieLink } from './cookieLink'
import { booksSearchNestLink } from './booksSearchNestLink'
import { networkStatusLink } from './networkStatusLink'

const uploadLink = createLink({
  uri: API_ENDPOINT
})

const client = new ApolloClient({
  link: ApolloLink.from([
    networkStatusLink,
    errorLink,
    cookieLink,
    authLink,
    booksSearchNestLink,
    uploadLink
  ]),
  cache: new InMemoryCache({
    typePolicies,
    dataIdFromObject
  })
})

export default client
